import React from 'react'
import { View } from 'react-native'
import { Text, Icon, useTheme } from '@ui-kitten/components'

export const HintView = function HintView({text, style, iconName, action=null, callToAction=null, appearance='default'}) {
  const theme = useTheme()

  let bgColors = {
    default: 'rgba(45, 170, 219, 0.2)',
    danger: 'rgba(255, 0, 0, 0.2)'
  }
  return (
    <View style={[{backgroundColor: bgColors[appearance], padding: 20, borderRadius: 4, flexDirection: 'row', alignItems: 'center'}, style]}>
      <Icon name={iconName}  width={16} height={16} fill={theme['text-basic-color']} />
      <Text style={{marginLeft: 10, marginRight: 10}}>
        {text + ' '}
        { action && callToAction && (
          <Text
            style={{textDecorationLine: 'underline', color: theme['color-info-500']}}
            onPress={action}
            accessibilityRole='button'
            accessibilityLabel={callToAction}
          >
            {callToAction}
          </Text>
        )}
      </Text>
    </View>
  )
}